import React from "react";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

const CButton = ({
  cText,
  cSrc,
  cTooltipText,
  cDisabled,
  cOnClick,
  cLink,
  CFullWidth,
}) => {
  const { t } = useTranslation();

  const handleClick = () => {
    if (cOnClick !== undefined) {
      cOnClick();
    }
  };
  return (
    <Tooltip title={t(cTooltipText)} arrow>
      <span>
        {(cText !== undefined && (
          <Button
            aria-label={cTooltipText}
            disabled={cDisabled}
            onClick={handleClick}
            color="primary"
            variant="contained"
            fullWidth={CFullWidth}
          >
            {cText}
          </Button>
        )) ||
          (cSrc !== undefined && (
            <Button
              aria-label={cTooltipText}
              disabled={cDisabled}
              onClick={handleClick}
              color="primary"
              variant="contained"
            >
              {cSrc}
            </Button>
          ))}
      </span>
    </Tooltip>
  );
};

export default CButton;
